import { LoadFileExt } from '@/classes/scenario/load/LoadFileExt';
import { LoadCurveExt } from '@/classes/scenario/load/LoadCurveExt';
import { LoadEnergyEfficiencyExt } from '@/classes/scenario/load/LoadEnergyEfficiencyExt';
import { LoadProfileExt } from '@/classes/scenario/load/LoadProfileExt';
import { ScenarioLoad } from '@/dto/scenario/load/ScenarioLoad';
import { DtoExt } from '@/classes/scenario/DtoExt';

export class ScenarioLoadExt extends DtoExt {

  public static fromDto(dto: ScenarioLoad): ScenarioLoadExt {
    return new ScenarioLoadExt({
      hasUploadedLoad: dto.hasUploadedLoad,
      file: dto.file && LoadFileExt.fromDto(dto.file),
      profile: dto.profile && LoadProfileExt.fromDto(dto.profile),
      calculatedCurveBefore: dto.calculatedCurveBefore && LoadCurveExt.fromDto(dto.calculatedCurveBefore),
      calculatedCurveAfter: dto.calculatedCurveAfter && LoadCurveExt.fromDto(dto.calculatedCurveAfter),
      hasEnergyEfficiency: dto.hasEnergyEfficiency,
      energyEfficiency: dto.energyEfficiency && LoadEnergyEfficiencyExt.fromDto(dto.energyEfficiency),
      loadPowerFactor: dto.loadPowerFactor,
      hasAdditionalConsumptionFromPVSystemAncillaryServices: dto.hasAdditionalConsumptionFromPVSystemAncillaryServices,
      additionalConsumptionPerDay: dto.additionalConsumptionPerDay
    });
  }

  public hasUploadedLoad: boolean | null = null;

  public file: LoadFileExt | null = null;
  public profile: LoadProfileExt | null = null;

  public calculatedCurveBefore: LoadCurveExt | null = null;
  public calculatedCurveAfter: LoadCurveExt | null = null;

  public hasEnergyEfficiency: boolean | null = null;
  public energyEfficiency: LoadEnergyEfficiencyExt | null = new LoadEnergyEfficiencyExt();

  public loadPowerFactor: number | null = null;

  public hasAdditionalConsumptionFromPVSystemAncillaryServices: boolean | null = null;
  public additionalConsumptionPerDay: number | null = null;

  constructor(options?: Partial<ScenarioLoadExt>) {
    super();
    if (options) {
      const optionsWithoutNulls = Object.fromEntries(Object.entries(options).filter(([, value]) => value !== null));
      DtoExt.assignToThis(this, optionsWithoutNulls);
    }
  }

  public toDto(): ScenarioLoad {
    return new ScenarioLoad({
      hasUploadedLoad: this.hasUploadedLoad,
      file: this.file && this.file.toDto(),
      profile: this.profile && this.profile.toDto(),
      calculatedCurveBefore: this.calculatedCurveBefore && this.calculatedCurveBefore.toDto(),
      calculatedCurveAfter: this.calculatedCurveAfter && this.calculatedCurveAfter.toDto(),
      hasEnergyEfficiency: this.hasEnergyEfficiency,
      energyEfficiency: this.energyEfficiency && this.energyEfficiency.toDto(),
      loadPowerFactor: this.loadPowerFactor,
      hasAdditionalConsumptionFromPVSystemAncillaryServices: this.hasAdditionalConsumptionFromPVSystemAncillaryServices,
      additionalConsumptionPerDay: this.additionalConsumptionPerDay
    });
  }
}
